/**
 * Reads what a view needs by id for a deep link (`/entities/:id`) that was not opened
 * from the console, so there is nothing in memory to show. It reads through the data source, not
 * the cache: a deep link is one read, and the page it opens keeps its own copy.
 */
import { blastElementId } from '../api-utils/blast';
import { extractS3File } from '../api-utils/s3';
import { getDataSource, type BlastRadiusScoreDocument } from '../data';

/** The log lines of an incident, for the remediation agent: read by the address of its file; empty when there are none. */
export async function loadIncidentLogs(s3Uri: string): Promise<unknown[]> {
  const res = await extractS3File(s3Uri);
  return res.success && Array.isArray(res.output) ? res.output : [];
}

/** The id in `/entities/:id`: the element the score belongs to, or the score's own id. */
export function blastScoreRouteId(score: BlastRadiusScoreDocument): string {
  return blastElementId(score) || String(score._id || '');
}

export async function loadBlastScore(id: string): Promise<BlastRadiusScoreDocument | null> {
  const scores = await getDataSource().listBlastRadiusScores();
  return scores.find((score) => blastScoreRouteId(score) === id) ?? null;
}
